// extracted by mini-css-extract-plugin
export default {"todo":"Todo_todo__x3Udk","todo__wrapper":"Todo_todo__wrapper__IdWBm"};